import * as React from 'react'
import { parse } from 'minidown/parser'
import { MinidownNode, MinidownNodeType } from 'minidown/nodes'
import flatMap from 'lodash/flatMap'

interface Props {
  value: string
}

export default function MinidownContent({ value }: Props) {
  const root = React.useMemo<MinidownNode>(() => {
    try {
      return parse(value)
    } catch (err) {
      console.error(
        `Unable to parse Minidown. The Minidown source is:\n\n${value}`,
        err
      )
      // Return the Minidown source as-is if we can't render it.
      return {
        type: MinidownNodeType.Root,
        children: [{ type: MinidownNodeType.Text, value }],
      }
    }
  }, [value])
  return React.createElement(React.Fragment, {}, ...visit(root))
}

function visit(node: MinidownNode): React.ReactNodeArray {
  switch (node.type) {
    case MinidownNodeType.Root:
      return flatMap(node.children, visit)
    case MinidownNodeType.Text:
      return [node.value]
    case MinidownNodeType.Emphasis:
      return [React.createElement('em', {}, ...flatMap(node.children, visit))]
    case MinidownNodeType.Strong:
      return [
        React.createElement('strong', {}, ...flatMap(node.children, visit)),
      ]
    default:
      return []
  }
}
